module.exports = __webpack_public_path__ + "03_hair_gold.6c8bb477.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/03_hair_gold.png
// module id = IAGT
// module chunks = 0